import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "search-input__icon search-input__icon--left box-border pl-1 usn relative" }
const _hoisted_2 = { class: "search-input__control flex-grow" }
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = { class: "text-sm text-text-default ml-2" }
const _hoisted_5 = {
  key: 0,
  class: "search-results__no-results usn"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_SearchPill = _resolveComponent("SearchPill")!
  const _component_SearchAiResults = _resolveComponent("SearchAiResults")!
  const _component_SearchResults = _resolveComponent("SearchResults")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal search-modal",
    onMousedown: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.hidePopup && _ctx.hidePopup(...args)))
  }, [
    _createElementVNode("div", {
      class: "popup-window--search-window rounded-md mr-auto mb-auto ml-auto",
      onMousedown: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["search-input flex items-center", { 'border-solid border-0 border-b border-dividers-default': _ctx.showAskAiNotesModal }]),
        onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.focusSearchField && _ctx.focusSearchField(...args)), ["stop"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("em", {
            class: "bg-icon-default m-auto block",
            style: _normalizeStyle(_ctx.getCustomIconStyle(_ctx.iconPath('search-alternative')))
          }, null, 4)
        ]),
        _cache[10] || (_cache[10] = _createTextVNode()),
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            ref: "searchTextInput",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
            placeholder: 
              _ctx.showAskAiNotesModal
                ? _ctx.translate('searchPlaceholderAskAiNotes')
                : _ctx.translate('searchPlaceholder')
            ,
            class: "search-input__field border-0 bg-transparent text-text-default placeholder-text-placeholder w-full border-box focus:outline-none",
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args))),
            onKeyup: [
              _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.handleEnter && _ctx.handleEnter(...args)), ["enter"])),
              _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.handleEsc && _ctx.handleEsc(...args)), ["esc"]))
            ]
          }, null, 40, _hoisted_3), [
            [_vModelText, _ctx.searchQuery]
          ])
        ]),
        _cache[11] || (_cache[11] = _createTextVNode()),
        (_ctx.showAskAiNotesModal)
          ? (_openBlock(), _createBlock(_component_ButtonCustom, {
              key: 0,
              class: "btn attention mr-2 rounded",
              type: "important",
              variation: 'small',
              text: _ctx.translate('Ask'),
              "custom-icon-name": 'send',
              "custom-icon-color": 'var(--iconBg)',
              "custom-icon-size": '16px',
              onClick: _ctx.askAi
            }, null, 8, ["text", "onClick"]))
          : _createCommentVNode("", true)
      ], 2),
      _cache[19] || (_cache[19] = _createTextVNode()),
      (!_ctx.aiGeneralSearch.open && !_ctx.showAskAiNotesModal)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["flex flex-row border-0 border-t border-solid border-dividers-default gap-2 px-4 py-2", { 'flex-wrap': _ctx.isMobile }])
          }, [
            _createVNode(_component_SearchPill, {
              icon: 'search-alternative',
              label: _ctx.translate('type'),
              "plural-label": _ctx.translate('types'),
              "show-search-input": false,
              "dropdown-options": _ctx.typeDropdownOptions,
              class: "shrink-0",
              onValueChange: _ctx.typeValueChange,
              onDropdownClosed: _ctx.searchPillDropdownClosed
            }, null, 8, ["label", "plural-label", "dropdown-options", "onValueChange", "onDropdownClosed"]),
            _cache[12] || (_cache[12] = _createTextVNode()),
            _createVNode(_component_SearchPill, {
              icon: 'circle',
              label: _ctx.translate('cardStatus'),
              "plural-label": _ctx.translate('statuses'),
              "show-search-input": false,
              "dropdown-options": _ctx.getStatusDropdownOptions,
              class: "shrink-0",
              onValueChange: _ctx.statusValueChange,
              onDropdownClosed: _ctx.searchPillDropdownClosed
            }, null, 8, ["label", "plural-label", "dropdown-options", "onValueChange", "onDropdownClosed"]),
            _cache[13] || (_cache[13] = _createTextVNode()),
            _createVNode(_component_SearchPill, {
              icon: 'folder',
              label: _ctx.translate('space'),
              "plural-label": _ctx.translate('spaces'),
              "dropdown-options": _ctx.spaceDropdownOptions,
              "dropdown-placeholder": _ctx.translate('space___'),
              onValueChange: _ctx.spaceValueChange,
              onDropdownClosed: _ctx.searchPillDropdownClosed
            }, null, 8, ["label", "plural-label", "dropdown-options", "dropdown-placeholder", "onValueChange", "onDropdownClosed"]),
            _cache[14] || (_cache[14] = _createTextVNode()),
            _createVNode(_component_SearchPill, {
              icon: 'paper-box',
              label: _ctx.translate('option.label.showArchived'),
              "single-value": true,
              "selected-value": _ctx.searchParams.archived,
              onValueChange: _ctx.archivedChange,
              onDropdownClosed: _ctx.searchPillDropdownClosed
            }, null, 8, ["label", "selected-value", "onValueChange", "onDropdownClosed"]),
            _cache[15] || (_cache[15] = _createTextVNode()),
            (_ctx.filtersNotDefault)
              ? _withDirectives((_openBlock(), _createBlock(_component_ButtonCustom, {
                  key: 0,
                  type: 'transparent hover:bg-hover-onHover p-0 ml-auto',
                  "custom-icon-name": 'x',
                  "custom-icon-color": '--var(iconDefault)',
                  "custom-icon-size": '16px',
                  "custom-icon-props": { margin: 0 },
                  "button-dimensions": { width: 22, height: 22 },
                  onClick: _ctx.resetFilters
                }, null, 8, ["onClick"])), [
                  [_directive_tooltip, {
            content: _ctx.translate('resetFilters'),
            placement: 'top',
          }]
                ])
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true),
      _cache[20] || (_cache[20] = _createTextVNode()),
      (_ctx.shouldShowAskAiSection)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "ask-ai flex items-center py-2 px-4 border-solid border-0 border-t border-b border-dividers-default -mt-px pt",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleAskAiClick && _ctx.handleAskAiClick(...args)))
          }, [
            _createElementVNode("em", {
              class: "custom-icons",
              style: _normalizeStyle(_ctx.getCustomIconStyle(_ctx.iconPath(_ctx.aiGeneralSearch.open ? 'chevron-left' : 'zap')))
            }, null, 4),
            _cache[16] || (_cache[16] = _createTextVNode()),
            _createElementVNode("div", _hoisted_4, _toDisplayString(!_ctx.aiGeneralSearch.open
              ? _ctx.translate('askAiAssistantSearch')
              : _ctx.translate('backToSearchResults')), 1),
            _cache[17] || (_cache[17] = _createTextVNode()),
            (!_ctx.aiGeneralSearch.open)
              ? (_openBlock(), _createElementBlock("em", {
                  key: 0,
                  class: "custom-icons ml-auto",
                  style: _normalizeStyle(_ctx.getCustomIconStyle(_ctx.iconPath('chevron-right')))
                }, null, 4))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _cache[21] || (_cache[21] = _createTextVNode()),
      (_ctx.aiGeneralSearch.open && !_ctx.showAskAiNotesModal)
        ? (_openBlock(), _createBlock(_component_SearchAiResults, {
            key: 2,
            "ai-generated-text": _ctx.aiGeneralSearch.generatedText,
            "ai-generic-links": _ctx.aiGeneralSearch.genericLinks,
            onHideSearchPopup: _ctx.hidePopup
          }, null, 8, ["ai-generated-text", "ai-generic-links", "onHideSearchPopup"]))
        : _createCommentVNode("", true),
      _cache[22] || (_cache[22] = _createTextVNode()),
      (_ctx.aiNotesSearch.open && _ctx.showAskAiNotesModal)
        ? (_openBlock(), _createBlock(_component_SearchAiResults, {
            key: 3,
            "ai-generated-text": _ctx.aiNotesSearch.generatedText,
            "ai-generic-links": _ctx.aiNotesSearch.genericLinks,
            onHideSearchPopup: _ctx.hidePopup
          }, null, 8, ["ai-generated-text", "ai-generic-links", "onHideSearchPopup"]))
        : _createCommentVNode("", true),
      _cache[23] || (_cache[23] = _createTextVNode()),
      (!_ctx.aiGeneralSearch.open && !_ctx.showAskAiNotesModal)
        ? (_openBlock(), _createElementBlock("div", {
            key: 4,
            class: "search-results flex flex-col overflow-hidden -mt-px",
            onMousemove: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.mouseMoveHandle && _ctx.mouseMoveHandle(...args))),
            onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
          }, [
            (!_ctx.searchResultsLength && _ctx.searchQuery && _ctx.responseQuery)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.translate('noResultsFound')), 1))
              : _createCommentVNode("", true),
            _cache[18] || (_cache[18] = _createTextVNode()),
            (_ctx.showSearchModal)
              ? (_openBlock(), _createBlock(_component_SearchResults, {
                  key: 1,
                  ref: "searchResults",
                  results: _ctx.results,
                  "results-label": _ctx.resultsLabel,
                  "is-grouped": false,
                  "search-query": _ctx.searchQuery,
                  type: _ctx.$constants.searchResultsType.SearchModal,
                  onSelectSearchResult: _ctx.selectSearchResult,
                  onLabelCliked: _ctx.labelClikedHandler
                }, null, 8, ["results", "results-label", "search-query", "type", "onSelectSearchResult", "onLabelCliked"]))
              : _createCommentVNode("", true)
          ], 32))
        : _createCommentVNode("", true)
    ], 32)
  ], 32))
}